import { twMerge } from "tailwind-merge";
import { Typography } from "@pondigitalsolutions/pon-component-library";

export interface QuoteProps {
  content: string;
  name: string;
}

export const Quote = ({ content, name }: QuoteProps) => {
  return (
    <blockquote
      className={twMerge(
        "mx-auto my-8 flex max-w-2xl flex-col gap-3 border-l-4 border-primary-500 bg-primary-50 px-5 pt-2 pb-4",
        "lg:my-14 lg:gap-4 lg:border-l-8 lg:px-8 lg:pt-4 lg:pb-6",
        "dark:bg-secondary-900"
      )}
    >
      <Typography
        size="6xl"
        aria-hidden="true"
        className="h-8 text-secondary-700 lg:h-10 lg:text-7xl dark:text-white/70"
      >
        “
      </Typography>
      <Typography className="leading-[150%] font-semibold text-secondary-700 lg:text-lg dark:text-white">
        {content}
      </Typography>
      <Typography
        size="xs"
        className="leading-[150%] font-normal text-tertiary-900 lg:text-sm dark:text-tertiary-100"
      >
        {name}
      </Typography>
    </blockquote>
  );
};
